import React, { FC } from 'react'

import { IconButton, Typography, useTheme, Tooltip, CircularProgress } from '@mui/material'
import TableCell from '@mui/material/TableCell'
import { useTranslation } from 'react-i18next'

import Iconify from '../Iconify/Iconify'

interface Props {
  onClick: () => void
  analyzed?: boolean
  loading?: boolean
}

export const TradeAiCell: FC<Props> = ({ onClick, analyzed = false, loading }) => {
  const { spacing, palette } = useTheme()
  const { t } = useTranslation()

  return (
    <TableCell
      sx={{
        fontSize: 14,
        fontWeight: 500,
        textAlign: 'right',
        padding: spacing(1.25),
        textTransform: 'capitalize',
        minWidth: spacing(8),
      }}
    >
      <Tooltip title={t('aiTableCell.tooltip')}>
        <IconButton
          disabled={loading}
          onClick={onClick}
          disableRipple
          sx={{
            padding: 0,
            minWidth: spacing(7.5),
            height: spacing(2.5),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 20,
            border: `1px solid ${palette.blue[500]}`,
            ...(!analyzed &&
              !loading && {
                backgroundColor: palette.blue[500],
              }),
          }}
        >
          {loading ? (
            <CircularProgress size={12} sx={{ color: palette.blue[500] }} />
          ) : (
            <>
              <Iconify
                icon={analyzed ? 'mingcute:eye-line' : 'mingcute:ai-line'}
                width={14}
                height={14}
                sx={{ color: analyzed ? 'primary.main' : palette.common.white }}
              />
              <Typography
                variant="body1"
                sx={{
                  color: analyzed ? palette.blue[500] : palette.common.white,
                  fontSize: 12,
                  fontWeight: 900,
                  fontFamily: 'Wix Madefor Display',
                  ml: 0.5,
                }}
              >
                {t('aiTableCell.label')}
              </Typography>
            </>
          )}
        </IconButton>
      </Tooltip>
    </TableCell>
  )
}

export default TradeAiCell
